__turbopack_context__.v({
  "className": "teko_db09bd4-module__j3O4-G__className",
});
